import { render, staticRenderFns } from "./AreaRiservataView.vue?vue&type=template&id=e528cce4&scoped=true&"
import script from "./AreaRiservataView.vue?vue&type=script&lang=js&"
export * from "./AreaRiservataView.vue?vue&type=script&lang=js&"
import style0 from "./AreaRiservataView.vue?vue&type=style&index=0&id=e528cce4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e528cce4",
  null
  
)

export default component.exports